import React from "react";
import { motion } from "framer-motion";
import { FileText, Send, Headphones, ClipboardCheck, Ticket, PlaneTakeoff } from "lucide-react";
import { useLang } from "@/context/LangContext";

const ICONS = [FileText, Send, Headphones, ClipboardCheck, Ticket, PlaneTakeoff];

export const ProcessSteps = () => {
  const { t } = useLang();
  const steps = t("process.steps");

  return (
    <section id="proceso" data-testid="process-section" className="relative py-16 md:py-28 bg-[#0B132B] ej-grain">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#FFD166] text-sm font-semibold uppercase tracking-wider">EuropeJobs</span>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl mt-2 text-white">{t("process.title")}</h2>
          <p className="text-slate-300 mt-3 max-w-2xl mx-auto">{t("process.subtitle")}</p>
          <div className="ej-accent-bar mx-auto mt-4" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((s, i) => {
            const Icon = ICONS[i] || FileText;
            return (
              <motion.div
                key={i}
                data-testid={`process-step-${i + 1}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative bg-[#1C2541] rounded-2xl border border-white/10 p-6 hover:border-[#FFD166]/50 card-hover"
              >
                <div className="absolute -top-3 -left-3 w-9 h-9 rounded-full bg-[#FFD166] text-[#0B132B] font-head font-extrabold flex items-center justify-center shadow-lg">
                  {i + 1}
                </div>
                <div className="w-12 h-12 rounded-xl bg-[#FFD166]/10 flex items-center justify-center">
                  <Icon className="text-[#FFD166]" size={24} />
                </div>
                <h3 className="font-head font-bold text-lg mt-4 text-white">{s.t}</h3>
                <p className="text-sm text-slate-300 mt-2">{s.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
